module.exports = __webpack_public_path__ + "img/working.4edbd868.png";